hasKeyArgs